import { render, staticRenderFns } from "./PapertonInfo.vue?vue&type=template&id=66250562&"
import script from "./PapertonInfo.vue?vue&type=script&lang=js&"
export * from "./PapertonInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports